// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    about_item: 'About {0}',
    activity_plural: '1#{0} activity#{0} activities',
    add: 'Add',
    AddMoreSpace: 'Upgrade now',
    ai_chat_label: 'Birdview AI assistant',
    ai_chat_placeholder: 'Type your message...',
    all_projects_label: 'All projects',
    approval_all_label: 'Parallel approval',
    approval_all_tooltip: 'All assigned approvers must approve for the expense to be approved.',
    approval_one_label: 'Initial approval',
    approval_one_tooltip: 'Approved by any one user. No further approvals needed.',
    approve_label: 'Approve',
    approved: 'Approved',
    approvers: 'Approver',
    archive_action_text: 'Archive',
    archive_date_label: 'Date archived',
    archived_by_label: 'Archived by',
    Attach: 'Attach file',
    attach_file_image: 'Attach file or image',
    automation_purchase_notes: 'Please contact <a href=\'mailto:billing@birdviewpsa.com\'>billing@birdviewpsa.com</a> if you\'d like to use a payment method other than a debit card.',
    automation_trial_description_end: ' and see Birdview automation in action!',
    automation_trial_description_middle: '30-day free trial',
    automation_trial_description_start: 'Start with our ',
    automation_trial_expired: 'Your trial has expired.',
    automation_trial_expired_notes: 'Please reach out to our <a href=\'mailto:support@birdviewpsa.com\'>support@birdviewpsa.com</a> for further assistance.',
    btn_reload: 'Reload',
    buy_subscription: 'Buy subscription',
    Cancel: 'Cancel',
    change: 'Change',
    checkbox_list_text: 'Multi-select',
    Close: 'Close',
    completeActivityConfirm: 'You have specified that this activity is 100% complete. Do you want to complete the activity? Press \'OK\' to change status, or \'Cancel\' otherwise.',
    completeActivityTitle: 'Do you want to complete this activity?',
    completeProjectConfirm: 'You have specified that this project is 100% complete. Do you want to complete this project? Press \'OK\' to change the status.',
    completeProjectTitle: 'Do you want to complete this project?',
    confirmCompleteActivityParents: 'Completing this activity will leave no uncompleted activities on this project (parent activity). Would you like to complete the project or parent activity, whichever appropriate, too?',
    confirmCompleteActivityParentsTitle: 'Set status for {0} as completed?',
    contact_us: 'Contact us',
    continue: 'Continue',
    copied_label: 'Copied',
    copy_link_feedback: 'Link copied.',
    copying_label: 'Copying',
    copyLink: 'Copy link',
    custom_field_label: 'Custom field',
    custom_form_label: 'Custom form',
    date_text: 'Date',
    DayAbbreviation: 'd',
    DayPluralFormat: '1#day#days',
    DayPluralFormatTemplate: '1#{0} day#{0} days',
    default_calendar_label: 'Default calendar',
    Delete: 'Delete',
    delete_confirmation: 'This action cannot be undone.',
    delete_permanently_text: 'Delete permanently',
    description_information: 'for {0}',
    disabled: 'Disabled',
    disabledUserText: '(disabled)',
    Download: 'Download',
    dropdown_text: 'Dropdown',
    Duplicate: 'Duplicate',
    Edit: 'Edit',
    ElapsedTime_Ago: '{0} ago',
    enabled: 'Enabled',
    Entity_Category: 'Category',
    Entity_Customer: 'Customer',
    Entity_Invoice: 'Invoice',
    Entity_Issue: 'Issue',
    Entity_JobRole: 'Job role',
    Entity_OAuthAccountClient: 'OAuth client',
    Entity_Portfolio: 'Portfolio',
    Entity_Priority: 'Priority',
    Entity_Project: 'Project',
    Entity_ProjectStatus: 'Status',
    Entity_Request: 'Request',
    Entity_Task: 'Task',
    Entity_TaskStatus: 'Status',
    Entity_User: 'User',
    Error_CantFindObjectTemplate: 'Operation could not be completed for the following reason(s): item (type: {entityName}, ID: {objectKey}) not found in the database.  This may be due to the deletion of, or lacking permission to view the item. Consult with your {brandName} administrator for possible causes.',
    error_notFullyCompleted: 'An object or user involved having been deleted or access permissions revoked by another user.',
    ErrorFileSizeLimit: 'The uploading of the file {0} could not be completed, because you cannot upload a file larger than ∼ {1} GB',
    ErrorUploadExceededText: 'The uploading of the file {0} could not be completed, because your account has run out of space.',
    ErrorUploadText: 'The uploading of the file {0} met with an unknown error and could not be completed. Please repeat the uploading process.',
    ErrorUploadTitle: 'Error uploading file.',
    ErrorVirusText: 'The file you\'re attempting to attach may contain a virus. Please remove the file and perform a computer scan for your safety.',
    ErrorVirusTitle: 'Virus file',
    exported: 'Exported',
    exporting: 'Exporting',
    failed: 'Failed',
    grid_item_readonly_description: 'Editing is not available in the grid. You can edit it in the details section.',
    help: 'Help',
    HourAbbreviation: 'h',
    HourPluralFormat: '1#hour#hours',
    HourPluralFormatTemplate: '1#{0} hour#{0} hours',
    HyperLinkTooltip: 'CTRL+Click to follow link',
    items_selected_plural: '1#{0} item selected#{0} items selected',
    madeBy: 'Powered by',
    MinuteAbbreviation: 'm',
    MinutePluralFormat: '1#{0} min#{0} min',
    more_counter_text: 'and {0} more',
    new_ai_chat_label: 'Start new chat',
    next: 'Next',
    no_items_selected: 'No items selected',
    None_Text: 'None',
    Not_set: 'Not set',
    Ok: 'OK',
    one_after_another_label: 'Sequential approval',
    one_after_another_tooltip: 'Approvers must approve in a set order, one after another.',
    open_details_new_tab: 'Open details in new tab',
    open_in_new_tab: 'Open in new tab',
    OpeningWindow: 'Opening...',
    OpenOriginal: 'Open original',
    OperationError_Title: 'The operation could not be completed',
    paragraph_text: 'Paragraph text',
    parentActivity: 'parent activity',
    PerDay: 'per day',
    PerWeek: 'per week',
    project_calendar_settings_label: 'Project calendar settings',
    project_custom_fields_label: 'Project custom fields',
    project_plural: '1#{0} project#{0} projects',
    reject_label: 'Reject',
    rejected: 'Rejected',
    Remove: 'Remove',
    request_has_been_sent_successfully: 'Request has been sent successfully. Success team will contact you.',
    Request_Trial: 'Try it now',
    Reset: 'Reset',
    Save: 'Save',
    saved: 'Saved',
    saving: 'Saving',
    Search: 'Search',
    select_placeholder: 'Select...',
    selection_mode_text: 'Selection mode',
    sending: 'Sending',
    setCompleted: 'Set as Completed',
    show_less_label: 'Show less',
    show_more_label: 'Show more',
    space_exceeded_description: 'There\'s not enough available storage space to store files.',
    space_exceeded_title: 'Storage is full',
    status: 'Status',
    submit: 'Submit',
    subscribe_trouble_description: 'Please contact <a href=\'mailto:success@birdviewpsa.com\'>success@birdviewpsa.com</a> to clarify your subscription status.',
    summary: 'Summary',
    time_input_placeholder: 'Enter time e.g. 2h 30m',
    timer_text: '1#{0} second#{0} seconds',
    title_notFullyCompleted: 'The operation could not be completed partially or in full',
    title_reload: 'Please, reload the page',
    total: 'Total',
    turn_off: 'Turn off',
    type: 'Type',
    Type_for_search: 'Type to search',
    Type_for_search_or_add: 'Type to search or add',
    Type_for_search_or_create: 'Type to search or create',
    unarchive_action_text: 'Unarchive',
    undo_label: 'Undo',
    undoing: 'Undoing',
    undone: 'Undone',
    upload: 'Upload',
    waitingForApproval: 'Waiting for approval',
    WebPushNotificationPanelLink: 'enable desktop notifications.',
    WebPushNotificationPanelText: '{brandName} needs your permission to ',
    you_user_text: '(you)',
};
